import { RoutePath } from '../../../config/routes';

import {
  IConfFooterLink,
  ISocialsFooterLinks,
} from './interfaces/IConfFooterLink';
import { TelegramSocialLink } from '../../../constants/TelegramHelpLink';

export const footerLinks: IConfFooterLink[] = [
  {
    id: 'link-1',
    label: 'Как сделать заказ',
    url: 'https://company.dotherapy.ru/info',
    isAppLink: false,
  },
  {
    id: 'link-2',
    label: 'О платформе',
    url: 'https://company.dotherapy.ru/platform',
    isAppLink: false,
  },
  {
    id: 'link-3',
    label: 'Блог',
    url: 'https://blog.dotherapy.ru/',
    isAppLink: false,
  },
  {
    id: 'link-4',
    label: 'Частые вопросы',
    url: '/#faq',
    isAppLink: false,
  },
  {
    id: 'link-5',
    label: 'Оплата',
    url: 'https://company.dotherapy.ru/info#payments',
    isAppLink: false,
  },
  {
    id: 'link-6',
    label: 'Вход на платформу',
    url: RoutePath.LOGIN,
    isAppLink: true,
  },
  {
    id: 'link-7',
    label: 'Контакты',
    url: 'https://company.dotherapy.ru/info#contacts',
    isAppLink: false,
  },
  {
    id: 'link-9',
    label: 'Возврат',
    url: 'https://company.dotherapy.ru/info#return',
    isAppLink: false,
  },
];

export const footerSocialsLinks: ISocialsFooterLinks[] = [
  {
    id: 'social-link-vk',
    link: 'https://vk.com/dotherapy',
    iconClassName: 'icon--vk',
  },
  {
    id: 'social-link-tg',
    link: TelegramSocialLink,
    iconClassName: 'icon--tg',
  },
  {
    id: 'social-link-yt',
    link: 'https://m.youtube.com/@DoTherapy',
    iconClassName: 'icon--yt',
  },
  {
    id: 'social-link-dzen',
    link: 'https://dzen.ru/dotherapy_ru',
    iconClassName: 'icon--spectrum',
  },
];
